import { API_URL } from '../../../app-config/constants';
import { get } from '../request';

getCategories.operation = 'READ';
getCategories.idFrom = () => 'auditLogCategories'; // stable resource
export function getCategories() {
    return get(`${API_URL}/audit-record/categories`);
}
